// inShip page strings. Keys are read as $t('inShip.<key>').
// The day <option> values stay 'Thứ 2'..'Thứ 6' (daymap + the Mattermost message use them);
// only the visible label is translated. Placeholder prefixes (F:, C:, Short:) are input syntax.
export default {
  en: {
    title: 'In Ship',
    subtitle: 'Print the shipper sheet for one delivery day.',
    cardTitle: 'Week',
    week: 'Week',
    day: 'Day',
    dayLabel: 'Day {n}',
    template: 'Template',
    templateLabel: 'Template {n}',
    drinks: 'Drinks',
    drinkPh: 'Short_name:drink name',
    messages: 'Messages to shippers',
    msgAllPh: 'F:Message to all shippers',
    msgConoPh: 'C:Message to all CONO shippers',
    print: 'Print',
    unknownError: 'Unknown error',
  },
  vi: {
    title: 'In Ship',
    subtitle: 'In phiếu giao hàng cho shipper theo từng ngày giao.',
    cardTitle: 'Tuần',
    week: 'Tuần',
    day: 'Ngày',
    dayLabel: 'Thứ {n}',
    template: 'Mẫu',
    templateLabel: 'Mẫu {n}',
    drinks: 'Nước uống',
    drinkPh: 'Tên_viết_tắt:tên nước',
    messages: 'Lời nhắn cho shipper',
    msgAllPh: 'F:Lời nhắn cho toàn bộ shipper',
    msgConoPh: 'C:Lời nhắn cho toàn bộ shipper CONO',
    print: 'In',
    unknownError: 'Lỗi không xác định',
  },
}
